import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../../common';
import { Text } from '../../typography';
export var cardHeaderKey = 'card-header';
var CardHeader = /** @class */ (function (_super) {
    __extends(CardHeader, _super);
    function CardHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardHeader.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(cardHeaderKey, props.className, { 'no-title': !props.title });
        var body = props.title ? React.createElement(Text, { type: 'tm', color: 't10' }, props.title) : props.children;
        return (React.createElement("div", { className: classNames }, body));
    };
    return CardHeader;
}(React.PureComponent));
export { CardHeader };
//# sourceMappingURL=index.js.map